export enum PriceSuffixType {
  Zero,
  NinetyNine,
  NinetyFive,
  Nine
}
